/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetMediaListsResponseAllOf,
    GetMediaListsResponseAllOfFromJSON,
    GetMediaListsResponseAllOfFromJSONTyped,
    GetMediaListsResponseAllOfToJSON,
} from './GetMediaListsResponseAllOf';
import {
    GetMediaListsResponseAllOfMediaLists,
    GetMediaListsResponseAllOfMediaListsFromJSON,
    GetMediaListsResponseAllOfMediaListsFromJSONTyped,
    GetMediaListsResponseAllOfMediaListsToJSON,
} from './GetMediaListsResponseAllOfMediaLists';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';

/**
 * PR TIMESメディアリストの一覧取得APIのレスポンス
 * @export
 * @interface GetMediaListsResponse
 */
export interface GetMediaListsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetMediaListsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetMediaListsResponse
     */
    message: string;
    /**
     * メディアリストの総数
     * @type {number}
     * @memberof GetMediaListsResponse
     */
    totalCount: number;
    /**
     * PRTIMESリストの一覧
     * @type {Array<GetMediaListsResponseAllOfMediaLists>}
     * @memberof GetMediaListsResponse
     */
    mediaLists: Array<GetMediaListsResponseAllOfMediaLists>;
}

export function GetMediaListsResponseFromJSON(json: any): GetMediaListsResponse {
    return GetMediaListsResponseFromJSONTyped(json, false);
}

export function GetMediaListsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaListsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'totalCount': json['total_count'],
        'mediaLists': ((json['media_lists'] as Array<any>).map(GetMediaListsResponseAllOfMediaListsFromJSON)),
    };
}

export function GetMediaListsResponseToJSON(value?: GetMediaListsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'total_count': value.totalCount,
        'media_lists': ((value.mediaLists as Array<any>).map(GetMediaListsResponseAllOfMediaListsToJSON)),
    };
}

